package co.uk.sacursoftware.ssinventory.data.remote

actual fun getDatabaseVariant(): String = DatabaseConfig.variant
